import { apiClient } from './config.js';

export type PresenceResourceType = 'notification_draft' | 'social_post' | 'article';

export interface PresenceOperator {
  operator_id: string;
  operator_display: string | null;
  opened_at: string | null;
  last_heartbeat_at: string | null;
}

export interface PresenceResponse {
  operators: PresenceOperator[];
}

export async function openPresence(
  resourceType: PresenceResourceType,
  resourceId: string | number,
): Promise<void> {
  await apiClient.post(`/admin/presence/${resourceType}/${resourceId}/open`);
}

export async function heartbeatPresence(
  resourceType: PresenceResourceType,
  resourceId: string | number,
): Promise<void> {
  await apiClient.post(`/admin/presence/${resourceType}/${resourceId}/heartbeat`);
}

export async function closePresence(
  resourceType: PresenceResourceType,
  resourceId: string | number,
): Promise<void> {
  await apiClient.post(`/admin/presence/${resourceType}/${resourceId}/close`);
}

export async function listPresence(
  resourceType: PresenceResourceType,
  resourceId: string | number,
): Promise<PresenceResponse> {
  const r = await apiClient.get<PresenceResponse>(
    `/admin/presence/${resourceType}/${resourceId}`,
  );
  return r.data;
}
